var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "global-dispatch-footer position-relative",
    class: [_vm.background.color || _vm.background.image ? 'layout-with-background' : 'layout-without-background'],
    style: {
      backgroundColor: _vm.background.color
    }
  }, [_c('div', {
    staticClass: "lazyload position-absolute h-100 w-100 background-image",
    attrs: {
      "data-bgset": _vm.background.image,
      "data-sizes": "auto"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row justify-content-center px-3 pb-1"
  }, [_c('div', {
    staticClass: "col-md-7 text-md-center"
  }, [_c('TitleSection', {
    attrs: {
      "title": _vm.title.text,
      "text-color": _vm.title.color
    }
  }), _vm._v(" "), _c('SubtitleSection', {
    attrs: {
      "subtitle": _vm.subtitle.text,
      "text-color": _vm.subtitle.color
    }
  }), _vm._v(" "), _c('SimpleParagraph', {
    class: {
      valentine: _vm.isHeadingTitle
    },
    attrs: {
      "paragraph": _vm.simpleParagraph
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row d-flex justify-content-center px-2 pt-3 pb-1"
  }, _vm._l(_vm.elements, function (element, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-3 text-center block-card",
      class: _vm.elements.length === 1 ? 'col col-md-6' : 'col-6'
    }, [_c('div', {
      staticClass: "block-card-item h-100",
      style: {
        backgroundColor: element.backgroundColor
      }
    }, [_c('MainImage', {
      staticClass: "mx-auto pb-3",
      attrs: {
        "src": element.src,
        "srcset": element.srcset,
        "alt": element.alt,
        "ratio": element.ratioImages
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "inner-content mx-auto"
    }, [_c('TitleSection', {
      staticClass: "pt-2",
      attrs: {
        "title": element.title,
        "text-color": element.titleColor
      }
    }), _vm._v(" "), element.simpleParagraphItem ? _c('SimpleParagraph', {
      staticClass: "mt-2 font-weight-normal h5",
      attrs: {
        "paragraph": element.simpleParagraphItem
      }
    }) : _vm._e(), _vm._v(" "), element.button.text ? _c('MdmLink', {
      staticClass: "btn",
      class: element.button.color,
      attrs: {
        "url": element.button.url
      },
      domProps: {
        "textContent": _vm._s(element.button.text)
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.$root.$emit('generic-tracking', $event, element.tracking);
        }
      }
    }) : _vm._e()], 1)], 1)]);
  }), 0), _vm._v(" "), _vm.legals ? _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('p', {
    staticClass: "col-10 col-sm-11 pt-4",
    domProps: {
      "textContent": _vm._s(_vm.legals)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center cta-block px-3"
  }, [_vm.buttonFirst.text ? _c('div', {
    staticClass: "cta col-md mt-2 text-md-right",
    class: {
      'text-md-center': _vm.buttonFirst.text && !_vm.buttonSecond.text
    }
  }, [_vm.buttonFirst.text ? _c('MdmLink', {
    staticClass: "btn",
    class: _vm.buttonFirst.color,
    attrs: {
      "url": _vm.buttonFirst.url
    },
    domProps: {
      "textContent": _vm._s(_vm.buttonFirst.text)
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.$root.$emit('generic-tracking', $event, _vm.tracking);
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.buttonSecond.text ? _c('div', {
    staticClass: "cta col-md mt-3 mt-md-2",
    class: {
      'text-md-center': !_vm.buttonFirst.text && _vm.buttonSecond.text
    }
  }, [_vm.buttonSecond.text ? _c('MdmLink', {
    staticClass: "btn",
    class: _vm.buttonSecond.color,
    attrs: {
      "url": _vm.buttonSecond.url
    },
    domProps: {
      "textContent": _vm._s(_vm.buttonSecond.text)
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.$root.$emit('generic-tracking', $event, _vm.tracking);
      }
    }
  }) : _vm._e()], 1) : _vm._e()])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };